import { AnchorNode } from '../anchor';
import { nextNode, prevNode } from '../domop';
import { getTextLengthByNode } from './getTextLengthByNode';
import { RangeInternal } from './RangeInternal';

export const clipSelectionRange = (root: AnchorNode, range: RangeInternal) => {
     /* tslint:disable */
    let startContainer: Node;
    let startOffset: number;
    let endContainer: Node;
    let endOffset: number;
    /* tslint:enable */
    let startContainerSearch = range.startContainer;
    let startOffsetSearch = range.startOffset;
    for (; startContainerSearch; ) {
        const anchorStart = root.findClosestByNode(startContainerSearch);
        if (anchorStart && anchorStart.selfOrAncestorDocumentContent()) {
            startContainer = startContainerSearch;
            startOffset = startOffsetSearch;
            break;
        }
        startContainerSearch = nextNode(startContainerSearch);
        startOffsetSearch = 0;
    }
    let endContainerSearch = range.endContainer;
    let endOffsetSearch = range.endOffset;
    for (; endContainerSearch; ) {
        const anchorEnd = root.findClosestByNode(endContainerSearch);
        if (anchorEnd && anchorEnd.selfOrAncestorDocumentContent()) {
            endContainer = endContainerSearch;
            endOffset = endOffsetSearch;
            break;
        }
        endContainerSearch = prevNode(endContainerSearch);
        endOffsetSearch = getTextLengthByNode(endContainerSearch);
    }
    if (startContainerSearch && endContainerSearch) {
        return new RangeInternal(startContainerSearch, startOffsetSearch, endContainerSearch, endOffsetSearch);
    }
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/clipSelectionRange.tsx